import { isPlatformUser } from '@/stores/auth'
import { useAuthStore } from '@/stores/authStore'
import { useGeneralSettingsStore } from '@/stores/settings/useGeneralSettingsStore'
import { isEqual } from 'lodash-es'
import { useEffect } from 'react'

/**
 * Syncs tenantSettings from authStore's user into useGeneralSettingsStore.
 * When refreshUser() updates the user (e.g. after tenant switch), this keeps
 * general settings in sync so project preferences, theme provider, etc. stay up-to-date.
 *
 * Mounted in the app layer (App.tsx) so cross-store subscription runs after all stores
 * are initialized, avoiding circular dependency / TDZ at module load time.
 */
export function GeneralSettingsAuthSync() {
	useEffect(() => {
		return useAuthStore.subscribe(state => {
			const user = state.user
			if (!isPlatformUser(user)) {
				return
			}
			const freshTenantSettings = user['tenant-settings'] ?? null
			const currentTenantSettings = useGeneralSettingsStore.getState().tenantSettings

			if (freshTenantSettings && !isEqual(freshTenantSettings, currentTenantSettings)) {
				useGeneralSettingsStore.getState().setTenantSettings(freshTenantSettings)
			}
		})
	}, [])
	return null
}
